import React, { Component } from 'react'
import { connect } from 'react-redux'
import { compose } from 'redux'
import { withRouter, NavLink } from "react-router-dom"
//import { NavLink} from "react-router-dom";
import axios from 'axios'
import { connectNode } from '../../../../utils/global'
import { escapeHtml } from '../../../../utils/textFunctions'
import '../../../../styles/assets/css/admin/form3.css'
import { loadLocationWithMessage } from '../../../../actions/location'

import WarningIcon from '@material-ui/icons/Warning'

import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import FormControl from '@material-ui/core/FormControl'
import Select from '@material-ui/core/Select'
import { ListSubheader } from '@material-ui/core'
import MenuItem from '@material-ui/core/MenuItem'
import AddBoxIcon from '@material-ui/icons/AddBox'
import CancelIcon from '@material-ui/icons/Cancel'
//import { makeStyles } from "@material-ui/core/styles";
import PatientHead3 from "../../patient/patient_head3"
import { contact, type, reason, outcome, yes_no } from '../variables/contact_logs.js'
import { completion, adherence_reason } from '../variables/treatment_plan.js'

import ReactHtmlParser from 'react-html-parser'
import 'react-quill/dist/quill.snow.css'
import { initAutosaveForForm2, ensureAutosaveInitialized, detachAutosave } from '../../../utils/draftAutosaveManager'

class PatientLogsOutcome extends Component {
  constructor(props) {
      super(props)
      this.quill = require('react-quill')
      this.state = {
          status: false,
          status_submit: true,
          message: '',
          date_log: new Date().toISOString().substring(0, 10),
          contact: 0,
          type: 0,
          reason: 0,
          reason_other: '',
          reason_list: [],
          outcome: [{ id:1, outcome: 0, outcome_txt: '' }],
          outcome_list: [],
          comments: '',
          dataList: [],
          update_treatment_plan: 0,
          getTreatmentPlan: [],
          update_mrtf: 0,
          getMRTF: [],
          editMode: false,
          getPID: 0,
      }
      this._draft = null;

      // Persist these fields (add/remove as you like)
      this.answerFields = [
        'status','status_submit','message',
        'date_log','contact','type','reason','reason_other',
        'outcome','comments',
        'update_treatment_plan','getTreatmentPlan',
        'update_mrtf','getMRTF',
        'editMode'
      ];

      // top-level numeric fields
      this.numericFields = new Set([
        'contact','type','reason','update_treatment_plan','update_mrtf'
      ]);
  }

  componentDidMount() {
    this._draft = initAutosaveForForm2(this, {
      //formId: 'admin_patient_logs_outcome',
      formId: this.getDraftFormId(),
      fields: this.answerFields,
      expireMs: 14 * 24 * 60 * 60 * 1000, // 14 days
      coerceIn: (name, v) => {
        // arrays of { id, outcome, outcome_txt }
        if (name === 'outcome' && Array.isArray(v)) {
          return v.map(item => ({
            ...item,
            outcome: Number(item.outcome) || 0
          }));
        }
        // simple numeric fields
        if (this.numericFields.has(name)) {
          const n = Number(v);
          return Number.isNaN(n) ? 0 : n;
        }
        return v;
      }
    });
    this.getData()
  }

  componentWillUnmount() {
    this._draft?.detach();
  }

  componentDidUpdate(prevProps) {
    const prevPid = prevProps.match.params.pid;
    const nextPid = this.props.match.params.pid;

    const prevCt = prevProps.match.params.ct_id;
    const nextCt = this.props.match.params.ct_id;

    const prevAppt = prevProps.match.params.appt_id;
    const nextAppt = this.props.match.params.appt_id;

    if (prevPid !== nextPid || prevCt !== nextCt || prevAppt !== nextAppt) {
      // stop old autosave
      this._draft?.detach();

      // (optional) reset state so you don't flash old values
      this.setState({
        status: false,
        status_submit: true,
        message: '',
        date_log: new Date().toISOString().substring(0, 10),
        contact: 0,
        type: 0,
        reason: 0,
        reason_other: '',
        outcome: [{ id:1, outcome: 0, outcome_txt: '' }],
        comments: '',
        dataList: [],
        update_treatment_plan: 0,
        getTreatmentPlan: [],
        update_mrtf: 0,
        getMRTF: [],
        editMode: false
      }, () => {
        // start autosave for the NEW pid
        this._draft = initAutosaveForForm2(this, {
          formId: this.getDraftFormId(),
          fields: this.answerFields,
          expireMs: 14 * 24 * 60 * 60 * 1000,
          coerceIn: (name, v) => {
            if (name === 'outcome' && Array.isArray(v)) {
              return v.map(item => ({ ...item, outcome: Number(item.outcome) || 0 }));
            }
            if (this.numericFields.has(name)) {
              const n = Number(v);
              return Number.isNaN(n) ? 0 : n;
            }
            return v;
          }
        });

        this.getData();
      });
    }
  }

  get_outcome_and_reasons = (editMode = false) => {
    axios({
      method: 'post',
      url: connectNode + 'functions/patient/get_dd_variable2',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json;charset=UTF-8',
      },
      data: { v_type: 8 },
    })
      .then((reasonResult) => {
        const get_reasons = reasonResult.data || [];

        return axios({
          method: 'post',
          url: connectNode + 'admin/patient/get_last_contact_log',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json;charset=UTF-8',
          },
          data: {
            uid: this.props.authReducer.uid,
            pid: this.props.match.params.pid,
            v_type: 9,
          },
        }).then((contactResult) => {
          const data = contactResult.data || [];

          const get_contact = data[0]?.value || null;
          const get_outcome = data[1]?.value || [];

          if (get_contact) {
            let get_outcomes = [];

            if (get_contact.outcomes) {
              const arr_outcomes = get_contact.outcomes.split(",");

              get_outcomes = arr_outcomes.map((item, i) => ({
                id: i + 1,
                outcome: item,
                outcome_txt: '',
              }));
            } else {
              get_outcomes = [{ id: 1, outcome: 0, outcome_txt: '' }];
            }

            this.setState({
              reason_list: get_reasons,
              outcome_list: get_outcome,
              contact: get_contact.contact,
              type: get_contact.type,
              reason: get_contact.reason,
              outcome: get_outcomes,
              comments: get_contact.comments,
            });
          } else {
            this.setState({
              reason_list: get_reasons,
              outcome_list: get_outcome,
            });
          }

          if (editMode === true) this.setEditMode();
        });
      })
      .catch((error) => {
        console.error('get_outcome_and_reasons error:', error);
      });
  };

  getData = () => {
    axios({
      method: 'post',
      url: connectNode + 'admin/patient/check_permission_get_data',
      headers: {
        'Accept': 'application/json',
        'Content-Type': 'application/json;charset=UTF-8'
      },
      data: {
        pid: this.props.match.params.pid,
        uid: this.props.authReducer.uid,
        user_role: this.props.authReducer.role,
      }
    })
    .then((result2) => {
      if(Array.isArray(result2.data) && result2.data.length) {
        if(this.props.match.params.ct_id > 0) {
          axios({
            method: 'post',
            url: connectNode + 'admin/contact_log/get_contact_log2',
            headers: {
              'Accept': 'application/json',
              'Content-Type': 'application/json;charset=UTF-8'
            },
            data: {
              pid: this.props.match.params.pid,
              appt_id: this.props.match.params.appt_id,
              ct_id: this.props.match.params.ct_id,
              uid: this.props.authReducer.uid,
              user_role: this.props.authReducer.role,
            }
          })
          .then((result) => {
            if(result['data'].length > 0) {
              this.setState({
                dataList: result['data'],
                getPID: result2['data'][0].uid,
              })
            }
          })
        } else this.get_outcome_and_reasons(false);
      } else {
        // no permission //
        this.props.history.push('/admin/patient_list')
      }
    })


  }

  getDraftFormId = (props = this.props) => {
    const { pid, ct_id, appt_id } = props.match.params || {};
    // pick what you want to scope by
    return `admin_patient_logs_outcome:pid=${pid}:ct=${ct_id || 0}:appt=${appt_id || 0}`;
  };

  setEditMode = () => {
    const data = this.state.dataList[0];
    const outcomeArray = data.outcome.split(",");
    const outcomeList = this.state.outcome_list;
    this.setState({
      ...data, editMode: true, date_log: data.date_contact, outcome: outcomeArray.map((x,i) => {
        const listValue = outcomeList.find(y => y.name == x);
        return {id: i + 1, outcome: listValue.vid, outcome_txt: ''}
      })
    })
  }

  handleChange = (e) => {
    const { name, value } = e.target;
    this.setState({ [name]: value }, () =>
      this._draft?.savePartial(name, this.state[name], this.state)
    );
  };

  handleChange2 = (e, name) => {
    const val = escapeHtml(e.target.value);
    this.setState({ [name]: val }, () =>
      this._draft?.savePartial(name, this.state[name], this.state)
    );
  };

  handleChange3 = (e, name, id, field) => {
    const getStateVal = [...this.state[name]];
    getStateVal[id][field] = escapeHtml(e.target.value);
    this.setState({ [name]: getStateVal }, () =>
      this._draft?.savePartial(name, this.state[name], this.state)
    );
  };

  handleChange4 = (contents) => {
    this.setState({ comments: contents }, () =>
      this._draft?.savePartial('comments', this.state.comments, this.state)
    );
  };

  handleChange5 = (e, name, id, field) => {
    const getStateVal = [...this.state[name]];
    getStateVal[id][field] = e.target.value;
    this.setState({ [name]: getStateVal }, () =>
      this._draft?.savePartial(name, this.state[name], this.state)
    );
  };

  appendOutcome = (name, fields) => {
    var newInput = fields[fields.length-1]
    var newInputID = newInput.id + 1
    this.setState(prevState => (
      { [name]: prevState[name].concat([{
          id: newInputID, outcome: 0, outcome_txt: '',
        }])
      }
    ))
  }

  removeInputSet1 = (name, id, fields) => {
    var getIndex = fields.findIndex(obj => obj.id === id)
    if (getIndex > 0) {
      fields.splice(getIndex, 1);
    }
    this.setState({ [name]: fields })
  }

  handleSubmit = async (e) => {
    e.preventDefault()
    if(this.state.contact == 0 || this.state.type == 0 ||
      this.state.reason == 0 || this.state.outcome[0].outcome == 0) {
        this.setState({
          message: 'Please fill in all information',
        })
        window.scrollTo(0, 0)
    } else {
      var chk_outcome = true
      this.state.outcome.map(each => {
        if(each.outcome == 0) {
          chk_outcome = false
        }
      })
      if(!chk_outcome) {
        this.setState({
          message: 'Please select outcome',
        })
        window.scrollTo(0, 0)
      } else {
        this.setState({
          status_submit: false,
          message: '',
        })
        var pid = this.props.match.params.pid
        var appt_id = 0
        if(this.props.match.params.appt_id > 0) {
          appt_id = this.props.match.params.appt_id
        }
        axios({
          method: 'post',
          url: connectNode + 'admin/contact_log/add_contact_log',
          headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json;charset=UTF-8'
          },
          data: {
            uid: this.props.authReducer.uid,
            pid: pid,
            user: this.state,
            appt_id: appt_id,
            ct_id: this.props.match.params.ct_id
          }
        })
        .then((result) => {
          if(result['data'] > 0) {
            this._draft?.clear();
            setTimeout(() => {
              this.props.onLoadLocation('/admin/patient_chart/'+pid, 'Saved successfully!')
              //window.location.href = '/admin/patient_chart/'+pid+'/1/2'
              this.props.history.push('/admin/patient_chart/'+pid+'/2/1')
            }, 900)
          }
        })
      }
    }
  }

  findLabelByValue = (arr, searchValue) => {
    var label = ''
    var result = arr.find(obj => {
      return obj.value == searchValue
    })
    if(typeof result !== "undefined") {
      label = result.label
    }
    return label
  }

  render() {
    const ReactQuill = this.quill
    return (
      <div className="admin_log_outcome box_border4">
        <div className="row">
          <div className="small-12 columns headerPage1">
            Contact Logs
          </div>
        </div>
        <div className="row">
          <div className="small-12 columns ">
            { this.state.message !== '' &&
            <div className="row warning_msg6">
              <div className="small-12 columns ">
                <div className="float_left1"><WarningIcon /></div>
                <div className="txt_warning_msg1">{ this.state.message }</div>
              </div>
            </div>
            }
            <div className="box_border5">
              <form id="log_outcome" onSubmit={this.handleSubmit}>
                <PatientHead3 />
                <div className="row">
                {this.state.dataList.length > 0 && !this.state.editMode &&
                  <div className="small-12 columns box_inner2 top_space1">
                    <div className="row" style={{display: 'flex'}}>
                      <div className="small-12 columns header1">Contact</div>
                      <div className="small-12 medium-9 columns bold button_header2">
                        {this.props.authReducer.uid == this.state.dataList[0].cid &&
                        <button type="button" onClick={() => this.get_outcome_and_reasons(true)}
                        className="edit_btn" >
                          Edit
                        </button>}
                      </div>
                    </div>
                    <div className="row">
                      <div className="small-12 medium-4 columns bold_text1">Date:</div>
                      <div className="small-12 medium-8 columns no_padding_left_float_left">
                      {this.state.dataList[0].conv_date}
                      </div>
                    </div>
                    <div className="row">
                      <div className="small-12 medium-4 columns bold_text1">Initiated by:</div>
                      <div className="small-12 medium-8 columns no_padding_left_float_left">
                      {this.findLabelByValue(contact, this.state.dataList[0].contact)}
                      </div>
                    </div>
                    <div className="row">
                      <div className="small-12 medium-4 columns bold_text1">Format:</div>
                      <div className="small-12 medium-8 columns no_padding_left_float_left">
                      {this.findLabelByValue(type, this.state.dataList[0].type)}
                      </div>
                    </div>
                    <div className="row">
                      <div className="small-12 medium-4 columns bold_text1">Reason:</div>
                      <div className="small-12 medium-8 columns no_padding_left_float_left">
                      {this.state.dataList[0].reason_name}
                      {this.state.dataList[0].reason==301 && '['+this.state.dataList[0].reason_other_txt+']'}
                      </div>
                    </div>
                    <div className="row">
                      <div className="small-12 medium-4 columns bold_text1">Outcome:</div>
                      <div className="small-12 medium-8 columns no_padding_left_float_left">
                      {this.state.dataList[0].outcome}
                      </div>
                    </div>
                    <div className="row">
                      <div className="small-12 medium-4 columns bold_text1">Comments:</div>
                      <div className="small-12 medium-8 columns no_padding_left_float_left">
                      {ReactHtmlParser(this.state.dataList[0].comments)}
                      </div>
                    </div>
                  </div>}
                {(this.state.dataList.length == 0 || this.state.editMode) &&
                <div>
                  <div className="small-12 columns box_inner2 top_space1">
                    <div className="row">
                      <div className="small-12 columns header1">Contact Detail</div>
                    </div>
                    <div className="row">
                      <div className="small-12 medium-4 columns bold_txt3">Date:</div>
                      <div className="small-12 medium-3 columns no_padding_left_float_left">
                      <TextField id="date_log" label="" onChange={this.handleChange}
                        variant="outlined" type="date" defaultValue={this.state.date_log}
                        InputProps={{ inputProps: { name: "date_log" }}} />
                      </div>
                    </div>
                    <div className="row">
                      <div className="small-12 medium-4 columns bold_txt3">Initiated by:</div>
                      <div className="small-12 medium-6 columns no_padding_left_float_left">
                        <FormControl variant="outlined">
                          <Select value={this.state.contact} variant="outlined" name="contact"
                            label="" onChange={(e) => this.handleChange(e, 'contact')}>
                            {contact.map(each =>
                              each.value != 2 &&
                              <MenuItem key={'ct'+each.value} value={each.value}>{each.label}</MenuItem>
                            )}
                          </Select>
                        </FormControl>
                      </div>
                    </div>
                    <div className="row">
                      <div className="small-12 medium-4 columns bold_txt3">Format:</div>
                      <div className="small-12 medium-6 columns no_padding_left_float_left">
                      <FormControl variant="outlined">
                        <Select value={this.state.type} variant="outlined" name="type"
                          label="" onChange={(e) => this.handleChange(e, 'type')}>
                          {type.map(each =>
                            <MenuItem key={'tp'+each.value} value={each.value}>{each.label}</MenuItem>
                          )}
                        </Select>
                      </FormControl>
                      </div>
                    </div>
                    <div className="row">
                      <div className="small-12 medium-4 columns bold_txt3">Reason:</div>
                      <div className="small-12 medium-6 columns no_padding_left_float_left">
                      <FormControl variant="outlined">
                        <Select value={this.state.reason} variant="outlined" name="reason"
                          label="" onChange={(e) => this.handleChange(e, 'reason')}>
                          {this.state.reason_list.map((each, index) => {
                            if (each.vid == 100 || each.vid == 200)
                              return(<ListSubheader key={'sh'+index}>{each.name}</ListSubheader>)
                            if (each.vid != 100 && each.vid != 200)
                              return(<MenuItem key={'rs'+each.vid} value={each.vid}>{each.name}</MenuItem>)
                          })}
                        </Select>
                      </FormControl>
                      {/* <MenuGroup label="optgroup label"><option aria-label="None" value="" /><option key={'rs'+each.vid} value={each.vid}>{each.name}</option> */}
                      </div>
                    </div>
                    {(this.state.reason == 301 || this.state.reason == 121) &&
                      <div className="row reason_list">
                        <div className="medium-4 columns">&nbsp;</div>
                        <div className="small-12 medium-6 columns no_padding_left_float_left">
                          <TextField label="Please specify" onChange={this.handleChange} name="reason_other"
                            variant="outlined" type="text" defaultValue={this.state.reason_other}
                            InputProps={{ inputProps: { name: "reason_other", maxLength: 250 }}} />
                        </div>
                      </div>}
                    <div className="row">
                      <div className="small-12 medium-4 columns bold_txt3">Outcome:</div>
                      <div className="small-12 medium-7 columns no_padding_left_float_left">
                      {this.state.outcome.map((val, index) =>
                      <div className="txt_todo" key={'oc'+index}>
                        <div className="small-11 columns no_padding_left_float_left">
                        <FormControl variant="outlined" key={"oc"+index} className="bottom_space_outcome_1">
                          <Select value={this.state.outcome[index].outcome} variant="outlined"
                            name={"outcome["+index+"]"} label=""
                            onChange={(e) => this.handleChange5(e, 'outcome', index, 'outcome')} >
                            {this.state.outcome_list.map((each, index) => {
                              if (each.vid == 100 || each.vid == 200)
                                return(<ListSubheader key={'sh2'+index}>{each.name}</ListSubheader>)
                              if (each.vid != 100 && each.vid != 200)
                                return(<MenuItem key={'oc'+index+each.vid} value={each.vid}>{each.name}</MenuItem>)
                            })}
                          </Select>
                        </FormControl>
                        {val.id === 1 &&
                          <AddBoxIcon className="add_icon"
                            onClick={ () => this.appendOutcome('outcome', this.state.outcome) }/>
                        }
                        {val.id > 1 && <CancelIcon className="remove_icon" onClick={ () => this.removeInputSet1('outcome', val.id, this.state.outcome) } />}
                        </div>
                        {this.state.outcome[index].outcome == 301 &&
                          <div className="small-12 columns no_padding_left_float_left reason_list">
                            <TextField label="Please specify" onChange={(e) => this.handleChange3(e, 'outcome', index, 'outcome_txt')}
                              variant="outlined" value={this.state.outcome[index].outcome_txt}
                              InputProps={{ inputProps: { name: "outcome_txt", maxLength: 250 }}} />
                          </div>}
                      </div>
                      )}
                      </div>
                      <div className="small-12 medium-1 columns no_padding_left_float_left">

                      </div>
                    </div>

                    <div className="row">
                      <div className="small-12 medium-4 columns bold_txt3">Comments:</div>
                      <div className="small-12 medium-6 columns no_padding_left_float_left">
                      <ReactQuill name="comments" modules={{toolbar: false}}
                        theme='snow' value={this.state.comments}
                        onChange={this.handleChange4}
                        style={{height: '200px'}} />
                      </div>
                    </div>
                  </div>
                </div>}
                </div>

                <div className="row top_space1">
                  <div className="small-12 columns text_align_right">
                  {this.state.dataList.length > 0 && !this.state.editMode &&
                    <a onClick={() => this.props.history.goBack()} className="go_back">Go Back</a>
                  }
                  {(this.state.dataList.length == 0 || this.state.editMode) &&
                    <span>
                    {this.state.status_submit &&
                    <Button variant="contained" color="primary" disableElevation
                     onClick={this.handleSubmit} type="submit">
                      Submit
                    </Button>}
                    {!this.state.status_submit &&
                    <Button variant="contained" disabled
                     onClick={this.handleSubmit} type="submit">
                      Submit
                    </Button>}
                    </span>}
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return state
}

const mapDispatchToProps = (dispatch) => ({
  onLoadPages(response) {
    dispatch({
      type: 'LOAD_USER_AUTH',
      payload: response,
    })
  },
  onLoadLocation(route, msg) {
    dispatch(loadLocationWithMessage(route, msg))
  },
})

export default compose(withRouter, connect(mapStateToProps, mapDispatchToProps))(PatientLogsOutcome)
